/**
 * @mergeTarget
 * @module Src/Parameters/String/Options
 */
/**
 * Enumerator of options for {@link Src/Parameters/String.LisioStringParameterNames.GOOGLE_TRANSLATION} parameter
 * @source
 */
var GoogleTranslationOptions;
(function (GoogleTranslationOptions) {
    GoogleTranslationOptions["FR"] = "fr";
    GoogleTranslationOptions["EN"] = "en";
    GoogleTranslationOptions["ES"] = "es";
    GoogleTranslationOptions["IT"] = "it";
    GoogleTranslationOptions["DE"] = "de";
    GoogleTranslationOptions["JA"] = "ja";
    GoogleTranslationOptions["RU"] = "ru";
    GoogleTranslationOptions["ZH_CN"] = "zh_CN";
    GoogleTranslationOptions["AR"] = "ar";
    GoogleTranslationOptions["PT"] = "pt";
    GoogleTranslationOptions["CA"] = "ca";
    GoogleTranslationOptions["KO"] = "ko";
    GoogleTranslationOptions["DA"] = "da";
    GoogleTranslationOptions["FI"] = "fi";
    GoogleTranslationOptions["CY"] = "cy";
    GoogleTranslationOptions["EL"] = "el";
    GoogleTranslationOptions["HE"] = "he";
    GoogleTranslationOptions["HI"] = "hi";
    GoogleTranslationOptions["NL"] = "nl";
    GoogleTranslationOptions["NO"] = "no";
    GoogleTranslationOptions["SV"] = "sv";
    GoogleTranslationOptions["CS"] = "cs";
    GoogleTranslationOptions["TH"] = "th";
    GoogleTranslationOptions["TR"] = "tr";
    GoogleTranslationOptions["UK"] = "uk";
    GoogleTranslationOptions["VI"] = "vi";
    GoogleTranslationOptions["YI"] = "yi";
    GoogleTranslationOptions["LB"] = "lb";
    GoogleTranslationOptions["PS"] = "ps";
    GoogleTranslationOptions["BG"] = "bg";
    GoogleTranslationOptions["ET"] = "et";
    GoogleTranslationOptions["HU"] = "hu";
    GoogleTranslationOptions["LV"] = "lv";
    GoogleTranslationOptions["LT"] = "lt";
    GoogleTranslationOptions["PL"] = "pl";
    GoogleTranslationOptions["RO"] = "ro";
    GoogleTranslationOptions["SK"] = "sk";
    GoogleTranslationOptions["SL"] = "sl";
    GoogleTranslationOptions["OC"] = "oc";
    GoogleTranslationOptions["BR"] = "br";
    GoogleTranslationOptions["EU"] = "eu";
    GoogleTranslationOptions["CO"] = "co";
    GoogleTranslationOptions["MFE"] = "mfe";
})(GoogleTranslationOptions || (GoogleTranslationOptions = {}));
export { GoogleTranslationOptions };
